document.documentElement.classList.add('js');

// ── Saveable confirmation for the online withdrawal function ─
(function () {
  var form = document.getElementById('WithdrawalForm');
  var storageKey = 'unsaid-withdrawal-confirmation';

  if (form) {
    form.addEventListener('submit', function () {
      var email = form.querySelector('input[name="contact[email]"]');
      var order = form.querySelector('input[name="contact[Bestelnummer]"]');
      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify({
          email: email ? email.value : '',
          order: order ? order.value : '',
          submittedAt: new Date().toISOString()
        }));
      } catch (error) {
        // The Shopify confirmation still works when browser storage is disabled.
      }
    });
  }

  var confirmation = document.querySelector('[data-withdrawal-confirmation]');
  if (!confirmation) return;

  var saved = {};
  try {
    saved = JSON.parse(window.sessionStorage.getItem(storageKey) || '{}');
  } catch (error) {
    saved = {};
  }

  var reference = confirmation.querySelector('[data-withdrawal-reference]');
  var submittedAt = saved.submittedAt ? new Date(saved.submittedAt) : new Date();
  var dateText = submittedAt.toLocaleString('nl-NL', {
    dateStyle: 'long',
    timeStyle: 'short'
  });

  if (reference && saved.order) {
    reference.textContent = 'BESTELNUMMER: ' + saved.order;
  }

  var download = confirmation.querySelector('[data-withdrawal-download]');
  if (!download) return;

  download.addEventListener('click', function () {
    var lines = [
      'UNSAID — BEVESTIGING HERROEPING',
      '',
      'Ontvangen op: ' + dateText,
      'Bestelnummer: ' + (saved.order || 'niet beschikbaar'),
      'E-mailadres: ' + (saved.email || 'niet beschikbaar'),
      '',
      'Je digitale verzoek om de online aankoop ongedaan te maken is ontvangen.',
      'Bewaar deze bevestiging bij je administratie.'
    ];
    var file = new Blob([lines.join('\n')], { type: 'text/plain;charset=utf-8' });
    var url = URL.createObjectURL(file);
    var link = document.createElement('a');
    link.href = url;
    link.download = 'UNSAID-herroeping-' + (saved.order || 'bevestiging').replace(/[^a-z0-9-]/gi, '') + '.txt';
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
  });
})();
